module.exports = __webpack_public_path__ + "d2c21012b0480af055c54994c5d5c607.MP3";